/* REACT IMPORTS */
import { Link, useLocation, useNavigate } from "react-router-dom";

/* MATERIAL TAILWIND COMPONENTS */
import { Button, Dialog, DialogBody } from "@material-tailwind/react";

/* REDUX IMPORTS */
import { useDispatch } from "react-redux";
import actions from "redux/actions/userAction";
import { useState } from "react";
import { IoClose } from "react-icons/io5";

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);

  return (
    <header className="bg-white py-1 header-shadow z-50 relative">
      <div className="container">
        <div className="flex items-center justify-between">
          {/* LEFT SECTION */}
          <div className="flex items-center gap-10">
            {/* LOGO */}
            <img
              src="https://storage.googleapis.com/cdn-roundtechsquare/nick-itkin/logos/nick-itkin-foundation-dark.png"
              className="object-contain w-[15vh] h-16"
              alt="The Nick Itkin Foundation"
            />

            {/* NAVIGATION LINKS */}
            <div className="flex items-center gap-8">
              <Link
                to="/contact-us"
                className={`block text-sm font-source font-medium relative ${
                  location.pathname === "/contact-us"
                    ? "text-primary"
                    : "text-black"
                } hover:text-primary transition-all duration-300 ease-in-out`}
              >
                Contact us
                {location.pathname === "/contact-us" && (
                  <div className="absolute -bottom-0.5 left-0 w-full h-[1.5px] bg-primary"></div>
                )}
              </Link>
            </div>
          </div>

          {/* RIGHT SECTION */}
          <Button
            onClick={() => setDeleteModal(!deleteModal)}
            className="px-5 py-2 shadow-none hover:shadow-none bg-primary hover:bg-opacity-70 transition-all duration-300 ease-in-out rounded-md text-sm font-source font-normal text-white normal-case"
          >
            Logout
          </Button>
        </div>
      </div>

      {/* DELETE MODAL */}
      <Dialog
        open={deleteModal}
        handler={() => setDeleteModal(!deleteModal)}
        size="xs"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-greyBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-sm font-source font-medium text-black">
                Confirmation
              </h5>
              <Button
                onClick={() => setDeleteModal(!deleteModal)}
                className="shadow-none p-1.5 hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-10 rounded-full transition-all duration-300 ease-in-out"
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5">
            <p className="text-sm font-source font-normal text-greyText">
              Are you sure you want to logout?
            </p>
          </div>

          {/* FOOTER */}
          <div className="px-5 py-3 border-t border-greyBorder flex items-center justify-end">
            <Button
              onClick={() => {
                dispatch(actions.setLoggedIn(false));
                dispatch(actions.setToken(null));
                dispatch(actions.setLoggedIn(false));
                dispatch(actions.setUser(null));
                navigate("/");
              }}
              className="px-5 py-2 shadow-none hover:shadow-none bg-primary hover:bg-opacity-70 transition-all duration-300 ease-in-out rounded-md text-sm font-source font-normal text-white normal-case"
            >
              Confirm
            </Button>
          </div>
        </DialogBody>
      </Dialog>
    </header>
  );
};

export default Header;
